import React, { useState } from 'react';
import { CALL_API, successResponse, notSuccessResponse } from '../../../util/api'

export const getLookupServiceLocation = async (param) => {

    try {
        const response = await CALL_API.post('Collection/ServiceLocationLookup', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const getLookupRole = async (param) => {


    try {
        const response = await CALL_API.post('Meter/RoleList', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const getLookupLocation = async () => {


    try {
        const response = await CALL_API.post('Location/Lookup');
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const clearCache = async () => {

    try {
        const response = await CALL_API.post('Collection/ClearCache');
        return successResponse(response.data);
    } catch (error) {
        return notSuccessResponse(error);
    }

}



export const getListOfValueByType = async (param) => {

    try {
        const response = await CALL_API.post('Collection/GetListOfValueByType', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const getLookupDepartment = async () => {

    try {
        const response = await CALL_API.post('Meter/DepartmentList');
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const getLookupWorkShift = async () => {

    try {
        const response = await CALL_API.post('EmployeeWorkShift/WorkShiftList');
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const setLocations = async (param) => {


    try {
        const response = await CALL_API.post('User/Location/import', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const insertUser = async (param) => {

    try {
        const response = await CALL_API.post('User/InsertUser', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const updatePassword = async (param) => {

    try {
        const response = await CALL_API.post('User/EditPassword', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const updatePasswordByUser = async (param) => {

    try {
        const response = await CALL_API.post('User/edit/password/info', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}




export const changeUserSignature = async (param) => {
    try {
        const response = await CALL_API.post('User/ChangeSignature', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

export const getSignature = async (param) => {
    try {
        const response = await CALL_API.post('User/GetSignature', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

export const uploadSignatureb64 = async (param) => {
    try {
        const response = await CALL_API.post('File/upload/b64', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

export const uploadSignaturefile = async (param) => {
    try {
        var bodyFormData = new FormData();
        bodyFormData.append('file', param);
        const response = await CALL_API.post('File/upload/SIGNATURE', bodyFormData);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}


export const updateUserInfo = async (param) => {

    try {
        const response = await CALL_API.post('User/UpdateUser', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const getUserInfo = async (param) => {

    try {
        const response = await CALL_API.post('User/GetUserDetail', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const getUserInfoByUser = async (param) => {

    try {
        const response = await CALL_API.post('User/GetUserInfo', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const deleteUser = async (param) => {

    try {
        const response = await CALL_API.post('User/DeleteUser', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}




export const getLocations = async (param) => {

    try {
        const response = await CALL_API.post('Location/List/Web', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const getLocationList = async (param) => {

    try {
        const response = await CALL_API.post('Location/List', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const setDropLocation = async (param) => {

    try {
        const response = await CALL_API.post('Location/drop', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const syncMachineByBranch = async (param) => {

    try {
        const response = await CALL_API.post('mc/web/sync/branch', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

export const getMachineCycle = async () => {

    try {
        const response = await CALL_API.post('mc/web/machine/cycle', {});
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

export const setMCWebAddV2 = async (machine, cycles) => {

    try {
        var payload = {
            machine: machine,
            machineCycle: cycles
        }

        const response = await CALL_API.post('mc/web/add/v2', payload);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const setMCWebUpdateV2 = async (machine, cycles) => {

    try {
        var payload = {
            machine: machine,
            machineCycle: cycles
        }

        const response = await CALL_API.post('mc/web/edit/v2', payload);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}
export const syncMachineByCode = async (param) => {

    try {
        const response = await CALL_API.post('mc/web/sync/code', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

export const getMachines = async (param) => {

    try {
        const response = await CALL_API.post('mc/web/list', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const updateLocation = async (param) => {

    try {
        const response = await CALL_API.post('Location/Location/Update', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const newLocation = async (param) => {

    try {
        const response = await CALL_API.post('Location/Location/Add', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}
export const deleteLocation = async (param) => {

    try {
        const response = await CALL_API.post('Location/Location/Delete', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const getLocationByPoint = async (param) => {

    try {
        const response = await CALL_API.post('Location/ByPoint', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const getLookupListOfValueByType = async (param) => {

    try {
        const response = await CALL_API.post('Collection/GetListOfValueByType', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}



export const setGaseRateUpdateStatus = async (param) => {

    try {
        const response = await CALL_API.post('GasRate/UpdateStatus', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const setGaseRateAdd = async (param) => {

    try {
        const response = await CALL_API.post('GasRate/Add', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}




export const getGaseRateLookup = async () => {

    try {
        const response = await CALL_API.post('GasRate/Lookup');
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const setGasRateUpdate = async (param) => {

    try {
        const response = await CALL_API.post('GasRate/Update', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const getGasList = async (param) => {

    try {
        const response = await CALL_API.post('GasRate/List', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}





export const setMCWebAdd = async (param) => {

    try {
        const response = await CALL_API.post('mc/web/add', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const setImportMachine = async (param) => {

    try {
        const response = await CALL_API.post('mc/web/import', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const setMCWebDelete = async (param) => {

    try {
        const response = await CALL_API.post('mc/web/delete', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const setMCWebUpdate = async (param) => {

    try {
        const response = await CALL_API.post('mc/web/edit', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const setVenderAdd = async (param) => {

    try {
        const response = await CALL_API.post('Vender/Add', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const getVenderLookup = async () => {

    try {
        const response = await CALL_API.post('Vender/Lookup');
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const setVenderUpdateStatus = async (param) => {

    try {
        const response = await CALL_API.post('Vender/UpdateStatus', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const setVenderUpdate = async (param) => {

    try {
        const response = await CALL_API.post('Vender/Update', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const getVenderList = async (param) => {
    try {
        const response = await CALL_API.post('Vender/List', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}



export const updateWDF = async (param) => {
    try {
        const response = await CALL_API.post('Location/WDF/Active', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

export const lookupLocationApi = async (param) => {
    try {
        const response = await CALL_API.post('Location/Lookup/search', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}


export const updateFoldPrice = async (param) => {
    try {
        const response = await CALL_API.post('Location/WDF/SetFoldPrice', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

export const getWebLocation = async (param) => {
    try {
        const response = await CALL_API.post('Location/List/Search', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}


export const getRoleList = async (param) => {
    try {
        const response = await CALL_API.post('Role/list', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}
export const getRoleLookup = async (param) => {
    try {
        const response = await CALL_API.post('Role/lookup', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}
export const addRole = async (param) => {
    try {
        const response = await CALL_API.post('Role/Add', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

export const editRole = async (param) => {
    try {
        const response = await CALL_API.post('Role/Edit', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}



export const regionList = async () => {
    try {
        const response = await CALL_API.post('Area/region/list', {});
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

export const provinceList = async (param) => {
    try {
        const response = await CALL_API.post('Area/province/list', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

export const districtList = async (param) => {
    try {
        const response = await CALL_API.post('Area/district/list', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

export const subdistrictList = async (param) => {
    try {
        const response = await CALL_API.post('Area/subdistrict/list', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

export const provinceUpsert = async (param) => {
    try {
        const response = await CALL_API.post('Area/province/upsert', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

export const districtUpsert = async (param) => {
    try {
        const response = await CALL_API.post('Area/district/upsert', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

export const subdistrictUpsert = async (param) => {
    try {
        const response = await CALL_API.post('Area/subdistrict/upsert', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}
export const userRoleUpdate = async (param) => {
    try {
        const response = await CALL_API.post('Role/User/Update', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}
export const userRoleList = async (param) => {
    try {
        const response = await CALL_API.post('Role/User/List', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}
export const getLookupMachineHistory = async (param) => {


    try {
        const response = await CALL_API.post('mc/history/retail', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}
export const getScreen = async (param) => {


    try {
        const response = await CALL_API.post('MasterPermission/byrole', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}



export const updateRoleScreen = async (param) => {

    try {
        const response = await CALL_API.post('MasterPermission/role/upsert', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const getOrderGasList = async (param) => {

    try {
        const response = await CALL_API.post('OrderGas/Web/List', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const keepLog = async (param) => {

    try {
        if (param.req?.length > 100) {
            param.req = param.req?.substring(0, 100)
        }
        const response = await CALL_API.post('LogActivity/keep', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}




export const getEmployeeLookupApi = async (param) => {

    try {
        const response = await CALL_API.post('User/Get/Employee/Lookup', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const getDropLocationApi = async (param) => {

    try {
        const response = await CALL_API.post('DeliveryLookup/location/list', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}







//export {
//    getLookupServiceLocation,
//    getLookupRole,
//}
